<!--
  Displays the current inshell lots for an Almondco user with the Inshell feature.
  Allows the user to manipulate the current lot and sequence numbers.
-->

<template>
  <SplitViewTemplate
    :screenConfig="data"
    :dataModel="formModel"
    :formConfig="setFormConfig"
  />
</template>

<script>
import SplitViewTemplate from "../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
import { InshellTabs, GetIndexByTabName } from "../../_models/tabdata/inventory/inshell";

export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate
  },
  data() { 
      return {
          validationSummary: [],
          formModel: {
            Instance: "",
            Variety: "",
            LotNo: "",
            NextLotNo: "",
            SequenceNo: "",
            MaxSequenceNo: ""
          },
          data: {
              title: "Inshell",
              pageRoute: "/almondco-inshell",
              exportFileName: "Current Lot List",
              selectedIndex: GetIndexByTabName("Current Lots"),
              tabs: InshellTabs,
              saveEndPoint: "AlmondcoInshellCurrentLots",
              recordEndPoint: "AlmondcoInshellCurrentLots",
              gridData: {
                  gridOptions: {
                      dataSource: {
                          endpoint: "AlmondcoInshellCurrentLots",
                          serverPaging: true,
                          allowGrouping: false
                      },
                      rowSelect: {
                          view: this,
                          page: "almondco-inshell",
                          mode: "review",
                          idProperty: "LotNo",
                          idMode: "Number"
                      }
                  },
                  noDataMessage: {
                    addNew: {
                      class: "no-data",
                      title: "No Current Inshell Lots",
                      message: "Currently there are not active inshell lots",
                    },
                  },
                  toolbar: {
                      search: true,
                      columnChooser: true,
                      expand: false
                  },
                  columns: [
                    {
                      screenField: "Instance",
                      dataField: "Instance"
                    },
                    {
                      screenField: "Variety",
                      dataField: "Variety"
                    },
                    {
                      screenField: "LotNo",
                      dataField: "LotNo"
                    },
                    {
                      screenField: "SequenceNo",
                      dataField: "SequenceNo"
                    }
                  ]
              }

          }
      };
  },
  computed:
  {
      setFormConfig() {
          const form = {
            headerToolbar: {
              closeSplit: true,
              save: true,
              audit: false,                
              toolBarFormLocation: "after"
            },
            formItems: [
              {
                itemType: "group",
                caption: "",
                colCount: 1,
                items: [
                  {
                    screenField: "Instance",
                    dataField: "Instance",
                    allowUpdate: false
                  },
                  {
                    screenField: "Variety",
                    dataField: "Variety",
                    allowUpdate: false
                  },
                  {
                    screenField: "LotNo",
                    dataField: "LotNo",
                    required: true,
                    editorOptions: {
                      onValueChanged: () => {
                        this.onLotNoValueChanged();
                      },
                      customFormat: true,
                      format: "#",
                      min: 1
                    }
                  },
                  {
                    screenField: "NextLotNo",
                    dataField: "NextLotNo",
                    allowUpdate: false
                  },
                  {
                    screenField: "SequenceNo",
                    dataField: "SequenceNo",
                    required: true,
                    editorOptions: {
                      customFormat: true,
                      format: "#",
                      min: 1,
                      max: this.formModel.MaxSequenceNo
                    },
                    validationRules: [
                      {
                        type: "range",
                        message: `Sequence # must be between 1 and ${this.formModel.MaxSequenceNo}.`,
                        min: 1,
                        max: this.formModel.MaxSequenceNo,
                      }
                    ]
                  },
                  {
                    screenField: "MaxSequenceNo",
                    dataField: "MaxSequenceNo",
                    allowUpdate: false
                  }
                ]
              }
            ]
          }
          return form;
      }
  },
  methods: {
    async onLotNoValueChanged(){
      // If the value is greater than the next available lot number
      // confirm with the user that they want to make the change.
      if(this.formModel.LotNo > this.formModel.NextLotNo){
        await this.$confirm(
          'Do you want to set the lot number to be greater than the next available\n lot number?',
          `${this.formModel.LotNo} was entered, the next available lot number is ${this.formModel.NextLotNo}.`
        );
      }


    }
  }
}
</script>
